import { Link } from "react-router-dom";

const RankersDashboard = () => {
  return (
    <div style={{ width: "100%", height: "100%", padding: "20px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginBottom: "25px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Link
            to="/rankers/dashboard"
            state={{ openDropdown: "Rankers" }}
            style={{
              fontSize: "2rem",
              border: "2px solid transparent",
              borderRadius: "6px",
              backgroundColor: "orange",
              color: "white",
              padding: "20px",
              textDecoration: "none",
              textAlign: "center",
              width: "90%",
              maxWidth: "1020px",
              display: "block",
              marginTop:"100px"
            }}
          >
            Rankers
          </Link>
        </div>

        {/* <div
          style={{
            marginBottom: "16px",
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Link
            to="/onlineContact"
            state={{ openDropdown: "Finance" }}
            style={{
              fontSize: "2rem",
              border: "2px solid transparent",
              borderRadius: "6px",
              backgroundColor: "#f59e0b",
              color: "white",
              padding: "20px",
              textDecoration: "none",
              textAlign: "center",
              width: "90%",
              maxWidth: "500px",
              display: "block",
            }}
          >
            Finance
          </Link>
          <Link
            to="/subscribe"
            state={{ openDropdown: "Library" }}
            style={{
              fontSize: "2rem",
              border: "2px solid transparent",
              borderRadius: "6px",
              backgroundColor: "#f59e0b",
              color: "white",
              padding: "20px",
              textDecoration: "none",
              textAlign: "center",
              width: "90%",
              maxWidth: "500px",
              display: "block",
            }}
          >
            Library
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default RankersDashboard;
